import { Collapse, collapseClasses, Stack, styled } from '@mui/material';
import { useCallback, useState } from 'react';

import ContactUsLink from './ContactUsLink';
import QuestionForm from './QuestionForm';
import SendLinkForm from './SendLinkForm';

export default function LoginHelpSection() {
    const [ showQuestionForm, setShowQuestionForm ] = useState(false);

    const handleContactClick = useCallback(() => {
        setShowQuestionForm(x => !x);
    }, []);

    return (
        <Root spacing={ 4 }>
            <SendLinkForm />

            <ContactUsLink onClick={ handleContactClick } />

            <Collapse in={ showQuestionForm }>
                <QuestionForm />
            </Collapse>
        </Root>
    );
}

const Root = styled(Stack)(({ theme }) => ({
    width: '100%',
    alignItems: 'center',
    maxWidth: theme.breakpoints.values.sm,

    [`.${ collapseClasses.root }`]: {
        width: '100%',
        maxWidth: theme.breakpoints.values.sm
    },

    [theme.breakpoints.up('sm')]: {
        button: {
            width: 'fit-content'
        }
    }
}));
